export class CreditAuth {
    public ssn: string;
    public creditAuthorized: string;
    public authorizedName: string;
    constructor() {
        this.ssn='';
        this.creditAuthorized='';
        this.authorizedName='';
    }
}
